import { toast } from "react-toastify";

export const CustomToaster = ({type, customized_message, api_message}) => {
    let tst = []
    if (type == "success") {
        tst = toast.success(
            customized_message,
            {
                position: "bottom-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                className: "toastify-color-success",
            }
        );
    } else if (type == "error"){
       tst = toast.error(
            customized_message + " " + api_message,
            {
                position: "bottom-right",
                autoClose: 10000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
                className: "toastify-color-error",
            }
        );
    }
    else if (type == "warning"){
        tst = toast.error(
             customized_message + " " + api_message,
             {
                 position: "bottom-right",
                 autoClose: 10000,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: true,
                 draggable: false,
                 progress: undefined,
                 className: "toastify-color-warning",
             }
         );
     }
     else if (type == "info"){
        tst = toast.error(
             customized_message + " " + api_message,
             {
                 position: "bottom-right",
                 autoClose: 10000,
                 hideProgressBar: false,
                 closeOnClick: true,
                 pauseOnHover: true,
                 draggable: false,
                 progress: undefined,
                 className: "toastify-color-info",
             }
         );
     }
    return toast
        
}